import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  NgZone,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-to-top.component.html',
  styleUrl: './scroll-to-top.component.scss',
})
export class ScrollToTopComponent {
  isVisible: boolean = false;
  private readonly threshold: number = 250;
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private readonly ngZone: NgZone,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.isBrowser) return;

    const scrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const shouldShow = scrollY > this.threshold;
    if (this.isVisible !== shouldShow) {
      this.ngZone.run(() => {
        this.isVisible = shouldShow;
      });
    }
  }

  scrollToTop(): void {
    if (!this.isBrowser) return;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    // Fallback for containers with internal scroll
    document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTo({ top: 0, behavior: 'smooth' });

    const dashMain = document.querySelector('.dash-main');
    if (dashMain) {
      dashMain.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
